import moment from 'moment'
import 'moment-timezone/builds/moment-timezone-with-data'
let defaultTimezone = 'Europe/London'

/**
 * @param {Mixed}
 * @description Creates a new instance of moment. This wrapper exists as
 * I wanted a single place to maintain the configuration of the library
 * and to ensure that everything uses the same pre-configured instance
 */
export default (...args) => moment(...args).tz(defaultTimezone)

/**
 * @param {*} timeZone
 * @returns {String}
 * @description Sets the default timezone
 */
export function setDefaultTimezone(timeZone) {
  defaultTimezone = timeZone
  return timeZone
}

// Export all of the other methods moment has
export * from 'moment'
